export const INSIGHT_ACTION_ERROR_CODES = [
  'AUTH_REQUIRED',
  'WORKSPACE_NOT_FOUND',
  'PERMISSION_DENIED',
  'PLATFORM_ACTIONS_DISABLED',
  'INSIGHT_ACTION_EXECUTION_DISABLED',
  'INSIGHT_NOT_FOUND',
  'INSIGHT_ACTION_RUN_NOT_FOUND',
  'INSIGHT_ACTION_ITEM_NOT_FOUND',
  'INSIGHT_DATA_STALE',
  'REVERT_NOT_ELIGIBLE',
  'VALIDATION_FAILED',
  'INSIGHT_ACTION_GROUP_UNKNOWN',
  'INSIGHT_ACTION_LIMIT_EXCEEDED',
  'ACTION_NOT_REVERSIBLE',
  'INSIGHTS_UNAVAILABLE',
] as const

export type InsightActionErrorCode = (typeof INSIGHT_ACTION_ERROR_CODES)[number]

export const CANCELED_CODE = 'CANCELED'

export interface InsightActionError {
  code: InsightActionErrorCode | typeof CANCELED_CODE | (string & {})
  detail: string
  canceled: boolean
}

const KNOWN: ReadonlySet<string> = new Set<string>(INSIGHT_ACTION_ERROR_CODES)

export function isInsightActionErrorCode(value: string): value is InsightActionErrorCode {
  return KNOWN.has(value)
}
